enum HeritageCategories {
  Movable = "Movable",
  Immovable = "Immovable",
}

export default HeritageCategories;
